/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({ organizationId: ZodTypes.Id });

export const PutOrganizationThumbnail = {
  id: 'organization-thumbnail.put',
  tag: 'Organization',
  summary: 'Put organization thumbnail',
  description:
    'Only organization owners may put the thumbnail.\n' +
    '\n' +
    'Images must be under 5MB in size and have equal width and height dimensions. \\\n' +
    'If the image is larger than 256px, it will be resized to these dimensions.',
  method: 'put',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) => `/organization/${params.organizationId}/thumbnail`,
  request: {
    params: Params,
    body: {
      content: {
        'application/json': {
          schema: ZodTypes.ThumbnailFormat,
        },
      },
    },
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.string().optional(),
        },
      },
    },
  },
} as const satisfies Endpoint;
